const privacyPolicy = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: [
            "At Altours Travel Agency, we prioritize your privacy and are committed to safeguarding the data you entrust with us.",
            "This Privacy Policy outlines how we collect, process, and protect your personal and usage data when using our platform.",
            "By accessing and using our services, you agree to comply with this Privacy Policy."
        ]
    },
    { 
        id: "data-privacy", 
        title: "2. Data Privacy", 
        content: [
            "We collect both personal and non-personal data to improve your experience and deliver personalized travel services.",
            "The data collected includes, but is not limited to:"
        ],
        list: [
            "User registration information",
            "Interaction data with our website and travel services",
            "Payment, billing, and booking details",
            "Customer support and feedback"
        ]
    },
    { 
        id: "terms-of-service", 
        title: "3. Terms of Service", 
        content: [
            "Our Terms of Service govern the use of the Altours platform and its offerings.",
            "By accessing our website, you agree to these terms, which cover acceptable usage, service limitations, and user responsibilities."
        ]
    },
    { 
        id: "user-rights", 
        title: "4. User Rights", 
        content: [
            "As a valued user, you have rights regarding your data, including:"
        ],
        list: [
            "Right to access, update, or delete your personal information",
            "Right to withdraw consent for data processing at any time",
            "Right to request corrections of inaccurate data"
        ]
    },
    { 
        id: "data-security", 
        title: "5. Data Security", 
        content: [
            "We implement robust security measures to protect your data from unauthorized access, misuse, or alteration.",
            "Your data is safeguarded through industry-standard encryption and security protocols."
        ]
    },
    { 
        id: "cookies", 
        title: "6. Cookies", 
        content: [
            "Altours uses cookies and similar tracking technologies to enhance user experience.",
            "Cookies help us understand usage patterns, improve content, and tailor services to your preferences."
        ]
    },
    { 
        id: "third-party", 
        title: "7. Third-Party Services", 
        content: [
            "We collaborate with trusted third-party services (e.g., payment gateways, cloud storage) to enhance platform functionality.",
            "These providers may process your data under their own privacy policies. We recommend reviewing their policies for more information."
        ]
    },
    { 
        id: "data-storage", 
        title: "8. Data Storage", 
        content: [
            "Your data is securely stored on servers protected by advanced encryption technologies.",
            "We retain data as long as necessary for service delivery or legal compliance. You can request data deletion or transfer at any time."
        ]
    },
    { 
        id: "data-transfers", 
        title: "9. Data Transfers", 
        content: [
            "Your data may be transferred to and processed in countries outside your own jurisdiction.",
            "We ensure all such transfers comply with relevant data protection laws and safeguard your information."
        ]
    },
    { 
        id: "policy-updates", 
        title: "10. Policy Updates", 
        content: [
            "Altours may update this Privacy Policy periodically to reflect changes in services, technologies, or legal requirements.",
            "We will notify users of significant updates and ensure the latest version is available on our website."
        ]
    }
];

export default privacyPolicy;